export const HEADER_MAX_HEIGHT_MOBILE_PIXELS = 75;
export const HEADER_EXPAND_ANIMATION_SECONDS = 0.4;
